import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastData {
  message: string;
  type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  // Signal que contiene la data del toast actual
  data = signal<ToastData | null>(null);

  show(message: string, type: ToastType = 'success') {
    this.data.set({ message, type });

    // Auto-ocultar después de 3 segundos
    setTimeout(() => {
      this.data.set(null);
    }, 3000);
  }
}